import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Typography from '../../atoms/typography';

const PromoTextWrapper = styled.div`
    display: flex;
`;

const PromoText = styled(Typography)`
  color: ${({ theme }) => theme.color.redError};
  justify-content: left;
  letter-spacing: normal;
  line-height: ${({ theme }) => theme.modularScale.sixteen};
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  white-space: pre-wrap;
`;

const PromoMessaging = (props) => (
  <PromoTextWrapper className={props.className} data-vwo-id="PromoMessaging">
    <PromoText element="span" like="label-7">
      {props.pdpText}
    </PromoText>
  </PromoTextWrapper>
);

PromoMessaging.defaultProps = {
  className: '',
  pdpText: ''
};

PromoMessaging.propTypes = {
  className: PropTypes.string,
  pdpText: PropTypes.string
};

export default PromoMessaging;
